module.exports = __webpack_public_path__ + "img/delete-right.e9eb0eba.svg";